import EntityFormProvider from '@shared/components/forms/auto-form/entity-form-provider/entity-form-provider.vue';
import StdForm from '@shared/components/forms/auto-form/std-form/std-form.vue';
import Vue from 'vue';
import { Component, Prop, Watch } from 'vue-property-decorator';
import moment from 'moment';
import { Entry } from '@entries/interfaces/entry';
import { library } from '@fortawesome/fontawesome-svg-core';
import { faSlidersH } from '@fortawesome/free-solid-svg-icons';

library.add(faSlidersH);

@Component({
  name: 'bpc-entry-form',
  components: {
    'bpc-std-form': StdForm,
  },
})
export default class EntryForm extends Vue {
  $refs: {
    // resourceForm: InstanceType<typeof ResourceForm> & { saveEntity(): void };
    stdForm: InstanceType<typeof StdForm> & {
      saveEntity(): void;
      formModel: any;
      onDeleteMediaFile(): void;
      searchEntity(): void;
      extraData: string | any;
      formProvider: EntityFormProvider;
    };
  };

  @Prop([String, Number]) readonly entityId: string | number;
  @Prop({ type: String, default: 'default' }) formConfigName: string;
  @Prop({ type: Boolean, default: false }) disabled: boolean;

  public entity: string = 'entry';
  public permissionEntityNameToUse: string = 'entries';
  public formModel: Entry = null;

  // created() {}
  mounted() {
    this.$root.$on('updateEntryPrice', event => {
      this.setEntryPrice();
    });

    this.$root.$on('updateEntryDate', event => {
      this.setEntryEndDate(this.$refs.stdForm?.formModel?.entryCategory);
    });
  }

  destroyed() {
    this.$root.$off('updateEntryPrice');
    this.$root.$off('updateEntryDate');
  }

  onFormSaved(e) {
    this.$emit('entity-saved', e);
  }

  onSavingEntity(event) {
    this.$emit('saving-entity', event);
  }

  deleteMediaFile(mediaId) {
    this.$emit('delete-media-file', { mediaId: mediaId, entityId: this.entityId });
  }

  saveEntity() {
    this.$refs.stdForm.saveEntity();
  }

  setEntityAttributesAfterSave() {
    const newEntity = {} as Entry;
    Object.keys(this.formModel).forEach(key => {
      this.$set(newEntity, key, null);
    });

    this.$set(newEntity, 'status', this.formModel.status);
    this.$set(this.$refs.stdForm, 'formModel', newEntity);
  }

  setSelectedContacts(contacts: any) {
    this.$set(this.$refs.stdForm.formModel, 'contact_id', contacts);
  }
  private getPriceParamsStringId() {
    return [
      this.$refs.stdForm?.formModel?.article,
      this.$refs.stdForm?.formModel?.price_category,
    ].join(',');
  }

  setEntryPrice() {
    const oldRelatedPriceParamsStr = this.getPriceParamsStringId();
    setTimeout(() => {
      const newRelatedPriceParamsStr = this.getPriceParamsStringId();
      if (newRelatedPriceParamsStr === oldRelatedPriceParamsStr) {
        const articleID = this.$refs.stdForm?.formModel?.article?.id;
        const priceCategoryID = this.$refs.stdForm?.formModel?.priceCategory?.id;
        const entriesNumber = this.$refs.stdForm?.formModel?.entries_number;
        const date = this.$refs.stdForm?.formModel?.date;
        const reductionArticles = this.$refs.stdForm?.formModel?.reductionArticles?.map(
          item => item.id,
        );
        if (articleID) {
          const basePath = this.$bpcApiRouteHelper.getEntityPath('entries');
          this.$bpcApi
            .post(basePath + '/entry-price', {
              articleID: articleID,
              priceCategoryID: priceCategoryID,
              reductionArticles: reductionArticles,
              entriesNumber: entriesNumber,
              date: date,
            })
            .subscribe(
              res => {
                this.$set(
                  this.$refs.stdForm.formModel,
                  'entries_price',
                  Number(res.data).toFixed(2),
                );
              },
              error => {
                console.log(error);
              },
            );
        }
      }
    }, 600);
  }

  setEntryEndDate(category) {
    const startDate = this.$refs.stdForm?.formModel?.date;
    if (startDate && category?.validity_period) {
      // validity_period is a duration in days. We have to add duration - 1 to the start date, so a duration of 1 day means it is valid today only
      const daysToAdd = Math.max(0, category.validity_period - 1);
      this.$refs.stdForm.formModel.end_date = moment(startDate)
        .add(daysToAdd, 'days')
        .format('YYYY-MM-DD');
    }
  }

  private modelLoaded;

  onModelLoaded(event) {
    this.modelLoaded = JSON.parse(JSON.stringify(this.$refs.stdForm?.formModel));
    this.$emit('model-loaded', event);
  }

  openAdjustEntryModal(): void {
    this.$emit('open-adjust-entry-modal');
  }

  @Watch('formModel', { immediate: true, deep: true })
  onFormModelChange() {
    this.$emit('input', this.formModel);
  }
}
